import { Role } from "@/types";
import { IDataProvider } from "@/store";

export interface IRoleState {
  role: Role | null;
  roles: Role[] | null;
  dataProvider: IDataProvider<Role>;
}

export const state: IRoleState = {
  role: null,
  roles: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
